'use client';

import { ComponentProps } from 'react';

import { cn } from '@/lib';

export const threeDeeClassNames = [
  'dark:from-card/90 dark:to-card/60 from-card/95 to-card/80 rounded-[calc(var(--radius)+0.25rem)] bg-gradient-to-tr',
  'ring-[0.5px] ring-black/15 shadow',
  'border border-black/10 border-t-white/10 border-r-white/5',
];

export function ThreeDee({ className, children, ...props }: ComponentProps<'div'>) {
  return (
    <div className={cn(...threeDeeClassNames, className)} {...props}>
      {children}
    </div>
  );
}
